// fiuhb_frontend/src/services/finance_attachment_services/expenseAttachmentService.js
import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const Documents_Base_Url = `${API_BASE_URL}/documents`;

// Expense Attachment Services
export const getExpenseAttachments = async (expenseId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Documents_Base_Url}/expenses/${expenseId}/attachments/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching expense attachments:', error);
    throw error;
  }
};

export const uploadExpenseAttachment = async (expenseId, formData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Documents_Base_Url}/expenses/${expenseId}/attachments/upload/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      body: formData, // FormData object with file and metadata
    });
    return response;
  } catch (error) {
    console.error('Error uploading expense attachment:', error);
    throw error;
  }
};

export const deleteExpenseAttachment = async (expenseId, attachmentId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Documents_Base_Url}/expenses/${expenseId}/attachments/${attachmentId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting expense attachment:', error);
    throw error;
  }
};

export const downloadExpenseAttachment = async (expenseId, attachmentId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Documents_Base_Url}/expenses/${expenseId}/attachments/${attachmentId}/download/?${params.toString()}`;
  console.log('DEBUG: Download URL:', url);
  
  try {
    const accessToken = localStorage.getItem('accessToken');
    console.log('DEBUG: Access token exists:', !!accessToken);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    console.log('DEBUG: Response status:', response.status);
    console.log('DEBUG: Response headers:', Object.fromEntries(response.headers.entries()));
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('DEBUG: Error response:', errorData);
      return {
        success: false,
        error: errorData.error || 'Failed to download attachment'
      };
    }

    // Get the filename from Content-Disposition header
    const contentDisposition = response.headers.get('Content-Disposition');
    console.log('DEBUG: Content-Disposition header:', contentDisposition);
    
    let filename = `expense_attachment_${attachmentId}`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      console.log('DEBUG: Filename match:', filenameMatch);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }
    console.log('DEBUG: Final filename:', filename);

    // Get the blob
    const blob = await response.blob();
    console.log('DEBUG: Blob size:', blob.size, 'type:', blob.type);

    // Create a download link and trigger it
    const url_blob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url_blob;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url_blob);

    console.log('DEBUG: Download completed successfully');
    return { success: true };
  } catch (error) {
    console.error('DEBUG: Download error:', error);
    return {
      success: false,
      error: error.message || 'An error occurred while downloading the attachment'
    };
  }
};